<template>
    <b-modal
    v-model="openModal"
    :title="company.nombre"
    size="xl"
    header-bg-variant="dark"
    header-text-variant="light"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    >
        <b-card no-body >
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.user-acordion variant="info">
                    <b-icon icon="search" aria-hidden="true"></b-icon>
                    Filtro de busqueda
                </b-button>
            </b-card-header>
            <b-collapse id="user-acordion" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <b-card-text>
                        <b-row>        
                            <b-col cols="12" md="4">
                                <label for="userName">Nombre</label>
                                <b-form-input id="userName" v-model="userName" @keydown.enter.prevent="getCompanyUsers()" placeholder="Nombre"></b-form-input>
                            </b-col>
                            <b-col cols="12" md="4">
                                <label for="userEmail">Email</label>
                                <b-form-input id="userEmail" v-model="userEmail" @keydown.enter.prevent="getCompanyUsers()" placeholder="Email"></b-form-input>
                            </b-col>
                            <b-col cols="12" md="4">
                                <label for="userPhoneNumber">Numero teléfono</label>
                                <b-form-input id="userPhoneNumber" v-model="userPhoneNumber" @keydown.enter.prevent="getCompanyUsers()" placeholder="Numero teléfono"></b-form-input>
                            </b-col>
                            
                            <b-col cols="12" md="12">
                                <div >
                                    <b-button variant="info" @click.prevent="getCompanyUsers()" class="mx-1">
                                        <b-icon icon="search" aria-hidden="true"></b-icon>
                                        Buscar
                                    </b-button>
                                    <b-button variant="warning" @click.prevent="clearFilterForm()" class="mx-1 text-white">
                                        <b-icon icon="backspace" aria-hidden="true"></b-icon>
                                        Limpiar
                                    </b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>
        <div class="text-center my-3">
            <b-card-text>
                <b-table 
                    responsive
                    :fields="fields" 
                    striped hover 
                    :items="usersLists">
                    <template v-slot:cell(nombre)="data">
                        {{ data.item.nombre }}
                        <b-badge pill variant="primary" v-if="data.item.isMaster === 1">Master</b-badge>
                    </template>
                    <template v-slot:cell(email)="data">
                        {{ data.item.email }}
                    </template>
                    <template v-slot:cell(telefono)="data">
                        {{ data.item.telefono }}
                    </template>
                    <template v-slot:cell(actions)="{ item }">
                        <b-button variant="danger" size="sm" v-b-tooltip.hover title="Nueva Contraseña" class="text-white" @click.prevent="openResetPassModal(item)">
                        <b-icon icon="wrench"></b-icon>
                    </b-button>
                    </template>
                </b-table>
                <template v-if="usersLists.length < 1">
                    <b-alert show variant="danger">
                        Lo sentimos, no se han encontrado resultados para su busqueda.
                    </b-alert>
                </template>
            </b-card-text>
            <template>
                <div class="mt-3">
                    <b-row>
                        <b-col cols="12" md="4">
                            <b-pagination 
                                size="md" 
                                pills 
                                :total-rows="paginator.totalPage" 
                                v-model="paginator.page" 
                                :per-page="1" 
                                @input="changePage" 
                                first-number 
                                last-number>
                            </b-pagination>
                        </b-col>
                        <b-col cols="12" sm="2">
                            <b-form-select @change="getCompanyUsers()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                        </b-col>
                    </b-row>
                </div>
            </template>
        </div>
        <template v-slot:modal-footer>
            <b-button size="sm" variant="danger" @click.prevent="$emit('close-modal')">
                    Cerrar
            </b-button>
        </template>
        <user-reset-password @close-modal="closeResetPasswordModal" :openModal="modalResetPassword" :user="userReset"/>
    </b-modal>
</template>

<script>
import { mapMutations } from 'vuex'
import userResetPassword from './UserPassword.vue'
export default {
    name: "CompanyUsersTableModal",
    props: {
        company: {
            type: Object
        },
        openModal: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            fields: [
                { key: 'nombre', label: 'Nombre Usuario', sortable: true},
                { key: 'email', label: 'Correo', sortable: true},
                { key: 'telefono', label: 'Teléfono', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
            
            pageSize: [10, 25, 50, 100],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            usersLists: [],
            pageOptions: "",
            userName: "",
            userEmail: "",
            userPhoneNumber: "",
            modalResetPassword: false,
            userReset: {},
        }
    },
    components: {
        userResetPassword
    },
    created(){
        this.getCompanyUsers();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getCompanyUsers(){
            this.setLoading(true)
            this.pageOptions = {
                                empresaId: this.company.id, 
                                pageNumber: this.paginator.page, 
                                pageSize: this.paginator.pageSize,
                                nombre: this.userName,
                                email: this.userEmail,
                                telefono: this.userPhoneNumber
                                }
            
            await this.$conectar.post('/admin/empresas/users/get-empresa-users-lists', this.pageOptions)
            .then(response =>{
                this.modalusersLists = true;
                this.usersLists = response.data.usersLists;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getCompanyUsers();
        },
        clearFilterForm(){
            this.userName = "";
            this.userEmail = "";
            this.userPhoneNumber = "";
        },
        openResetPassModal(user){
            this.modalResetPassword = true;
            this.userReset = user;
        },
        closeResetPasswordModal(){
            this.modalResetPassword = false;
            this.userReset = {};
        }
    }
    

};

</script>
